import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';

import Spinner from 'components/atomic/Spinner';

import MeetingListItem from './MeetingListItem';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.spaces.regular}px;
`;

const MeetingList = ({ loading, items }) => (
  <StyledContainer>
    {!loading &&
      items?.map(({ name, start, end }) => (
        <MeetingListItem key={`${name}-${start}-${end}`} name={name} start={start} end={end} />
      ))}
    {loading && <Spinner />}
  </StyledContainer>
);

MeetingList.propTypes = {
  loading: PropTypes.bool,
  items: PropTypes.array,
};

export default MeetingList;
